import React from 'react';
import './AnnouncementDetailModal.css';

const PRIORITY_CONFIG = {
  urgent: { color: '#dc2626', bg: '#fef2f2', border: '#fecaca', icon: '🚨', label: 'URGENT' },
  high:   { color: '#ea580c', bg: '#fff7ed', border: '#fed7aa', icon: '⚠️', label: 'HIGH'   },
  medium: { color: '#d97706', bg: '#fffbeb', border: '#fde68a', icon: '📌', label: 'MEDIUM' },
  low:    { color: '#16a34a', bg: '#f0fdf4', border: '#bbf7d0', icon: '💬', label: 'LOW'    },
};

const AnnouncementDetailModal = ({ visible, onClose, announcement }) => {
  if (!visible || !announcement) return null;

  const priorityKey = announcement.priority?.toLowerCase() || 'medium';
  const p = PRIORITY_CONFIG[priorityKey] ?? PRIORITY_CONFIG.medium;

  return (
    <div className="adm-overlay" onClick={onClose}>
      <div className="adm-shell" onClick={e => e.stopPropagation()}>

        {/* Priority accent bar */}
        <div className="adm-accent-bar" style={{ background: p.color }} />

        {/* Header */}
        <div className="adm-header">
          <div className="adm-header-left">
            <div className="adm-header-icon">📢</div>
            <div>
              <div className="adm-title">Announcement</div>
              <div className="adm-subtitle">Course Communication</div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span className="adm-priority-badge" style={{
              background: p.bg,
              color: p.color,
              border: `1px solid ${p.border}`
            }}>
              {p.icon} {p.label}
            </span>
            <button className="adm-close-btn" onClick={onClose}>✕</button>
          </div>
        </div>

        {/* Body */}
        <div className="adm-body">

          {/* Title */}
          <div className="adm-field">
            <label className="adm-label">Title</label>
            <div className="adm-value-title">{announcement.title}</div>
          </div>

          {/* Message */}
          <div className="adm-field">
            <label className="adm-label">Message</label>
            <div className="adm-value-body">{announcement.body}</div>
          </div>

          {/* Meta */}
          <div className="adm-meta-grid">
            <div className="adm-meta-item">
              <span className="adm-meta-icon">👤</span>
              <div className="adm-meta-content">
                <span className="adm-meta-label">From</span>
                <span className="adm-meta-value">{announcement.instructorName || 'Admin'}</span>
              </div>
            </div>
            <div className="adm-meta-item">
              <span className="adm-meta-icon">📅</span>
              <div className="adm-meta-content">
                <span className="adm-meta-label">Sent</span>
                <span className="adm-meta-value">{new Date(announcement.createdAt).toLocaleString()}</span>
              </div>
            </div>
            {announcement.courseName && (
              <div className="adm-meta-item">
                <span className="adm-meta-icon">📚</span>
                <div className="adm-meta-content">
                  <span className="adm-meta-label">Course</span>
                  <span className="adm-meta-value">{announcement.courseName}</span>
                </div>
              </div>
            )}
          </div>

        </div>

        {/* Footer */}
        <div className="adm-footer">
          <button className="adm-close-full-btn" onClick={onClose}>Close</button>
        </div>

      </div>
    </div>
  );
};

export default AnnouncementDetailModal;